import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "app/providers/ThemeProviders";
import { ErrorBoundary } from "app/providers/ErrorBoundary";
import { StoreProvider } from "app/providers/StoreProvider";
import { ApiProvider } from "app/api/APIProvider";
import App from "./app/App";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <BrowserRouter
         // basename="/"
        basename="/fingram-game"
    >
        <StoreProvider>
            <ErrorBoundary>
                <ThemeProvider>
                    <ApiProvider>
                        <App />
                    </ApiProvider>
                </ThemeProvider>
            </ErrorBoundary>
        </StoreProvider>
    </BrowserRouter>
);
